import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AppContext, DecryptSession } from "../../Context/Provider";
// Adjust the import path as necessary

const ProtectedRoute = ({ element, allowPasswordChange = false }) => {
  const { secretKey } = useContext(AppContext);
  const plainData = DecryptSession(secretKey, "userId");
  const isAuthenticated = plainData?.data?.authenticated === true;
  const mustChangePassword = plainData?.data?.mustChangePassword;

  if (!isAuthenticated) {
    // The cookie is HttpOnly; this metadata only controls navigation.
    return <Navigate to="/login" replace />;
  }

  if (mustChangePassword && !allowPasswordChange) {
    return <Navigate to="/change-password" replace />;
  }

  // Backend authentication remains authoritative for every protected request.
  return element;
};

export default ProtectedRoute;
